import { Link } from 'react-router-dom'
import SEOHead from '../components/SEOHead'
import GallerySection from '../components/GallerySection'
import ContactForm from '../components/ContactForm'
import { useCmsPage } from '../hooks/useCmsPage'

export default function PrivatfestPage() {
  const { page } = useCmsPage('privatfest')

  const title = page?.meta_title || 'DJ til privatfest — Casper DJ'
  const description =
    page?.meta_description ||
    'Søger du en DJ til din privatfest? CasperDJ sikrer, at musikvalget underbygger den stemning, du ønsker – om det så er lounge, disco-brag eller et sted derimellem., Søger du en DJ til din privatfest? CasperDJ sikrer, at musikvalget underbygger den stemning, du ønsker – om det så er lounge, disco-brag eller et sted derimellem.'

  return (
    <div className="bg-neutral-950 text-white min-h-screen">
      <SEOHead title={title} description={description} />

      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-48 md:pb-24 border-b border-neutral-900 bg-neutral-900/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
                Dj til privatfest
              </span>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white leading-tight">
                Ønsker du en fortryllende aften til din privatfest?
              </h1>
              <p className="text-base sm:text-lg text-neutral-300 leading-relaxed">
                Lad mig være med til at gøre din fest til en uforglemmelig begivenhed! Med års erfaring som DJ til private arrangementer kan jeg skabe den perfekte atmosfære, uanset om det er en fødselsdagsfest, en jubilæumsfejring eller bare en hyggelig sammenkomst med venner og familie. Med et bredt udvalg af musikgenrer og en professionel tilgang til lyd- og lysopsætning, garanterer jeg, at din fest bliver en succes! Lad os sammen skabe minder for livet på din næste private begivenhed med CasperDJ ved roret.
              </p>
              <div className="pt-2 flex flex-wrap gap-4">
                <Link
                  to="/kontakt"
                  className="px-8 py-3.5 bg-gold-400 text-neutral-950 font-bold text-sm uppercase tracking-wider rounded-xl hover:bg-gold-300 transition-colors shadow-lg cursor-pointer"
                >
                  Kontakt mig
                </Link>
                <a
                  href="tel:+4530405006"
                  className="px-6 py-3.5 border border-neutral-800 bg-neutral-900 text-white font-bold text-sm uppercase tracking-wider rounded-xl hover:border-gold-400/50 hover:text-gold-400 transition-colors cursor-pointer flex items-center gap-2 whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone text-gold-400 text-xs" aria-hidden="true" />
                  <span className="whitespace-nowrap">+45 30 40 50 06</span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="relative aspect-video lg:aspect-[4/3] rounded-3xl overflow-hidden border border-neutral-800 shadow-2xl bg-neutral-900">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/bce4b86c-87d9-405d-a99b-f30b07aaa8a2/img-9394.jpg"
                  alt="Casper DJ til privatfest"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vi skaber stemningen */}
      <section className="py-20 bg-neutral-950 border-b border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto space-y-6 text-neutral-300 leading-relaxed">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight">
              Vi skaber stemningen
            </h2>

            <p className="text-base sm:text-lg">
              Middag for de nærmeste, konfirmationsfest i baghaven, rund fødselsdag i forsamlingshuset eller{' '}
              <Link to="/bryllup" className="text-gold-400 hover:underline font-medium">
                bryllup
              </Link>{' '}
              på slottet? Hos{' '}
              <Link to="/" className="text-gold-400 hover:underline font-medium">
                CasperDJ
              </Link>{' '}
              har vi professionelt udstyr til ethvert set-up, stort som småt.
            </p>

            <p className="text-base sm:text-lg">
              Som dj til privatfesten, så sikrer vi, at musikvalget underbygger den stemning, du ønsker <strong>–</strong> om det så er lounge, disco-brag eller et sted derimellem. Og vi sikrer, at det hele kører på skinner, så der kun er tilbage for dig at nyde din privatfest og dine gæster.
            </p>

            <div className="pt-4 border-t border-neutral-900 space-y-3">
              <h3 className="text-xl font-bold text-white">
                Skræddersyet musik til privatfesten
              </h3>
              <p>
                Det er en selvfølge, at musikudvalget er tilpasset kunden, og vi spiller al slags musik. Diskoteket er på plads, inden gæsterne ankommer og pakket sammen igen, når de sidste er på vej hjem.
              </p>
              <p>
                Skal musikken indpasses andre indslag, er vi altid parat med vejledning og gode idéer. Mangler I derfor en dj til privatfesten, så{' '}
                <Link to="/kontakt" className="text-gold-400 hover:underline font-medium">
                  kontakt
                </Link>{' '}
                os i god tid, så vi sammen kan skabe et vellykket arrangement.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CasperDJ sikrer altid */}
      <section className="py-20 bg-neutral-900/30 border-b border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center mb-14">
            <span className="text-xs font-semibold tracking-widest text-gold-400 uppercase">
              Kvalitet og tryghed
            </span>
            <h2 className="text-3xl font-extrabold text-white mt-1">
              CasperDJ sikrer altid
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="p-8 rounded-2xl bg-neutral-950 border border-neutral-800 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center text-lg">
                <i className="fa-solid fa-shield-check" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-white">
                Professionel afvikling af jeres fest
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                Vi har ekspertisen og erfaringen til at sikre en professionel afvikling af jeres fest. Fra den indledende planlægning til den sidste tone på dansegulvet sørger vi for, at alt forløber gnidningsløst. Vi koordinerer hver eneste detalje, så I kan slappe af og nyde festen uden bekymringer.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-neutral-950 border border-neutral-800 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center text-lg">
                <i className="fa-solid fa-music" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-white">
                Et varieret musikudvalg, der kan tilpasses forskellige kulturer og generationer
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                Vi tilbyder et bredt udvalg af musikgenrer og sange, der kan tilpasses enhver smag og præference. Uanset om jeres gæster foretrækker klassiske hits, de nyeste top 40-hits eller internationale favoritter, har vi musikken, der passer til. Vores mål er at skabe en festlig stemning, der appellerer til alle og får alle til at danse hele natten.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-neutral-950 border border-neutral-800 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center text-lg">
                <i className="fa-solid fa-clock" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-white">
                Opstilling af diskotek inden gæsternes ankomst og hurtig nedpakning efter festen
              </h3>
              <p className="text-sm text-neutral-300 leading-relaxed">
                Vi sørger for at have alt klar til festen, før gæsterne ankommer, og vi er lynhurtige til at pakke ned, når festen er ovre.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <GallerySection
        gallerySlug="privatfest-billeder"
        title="Billeder fra privatfester"
        subtitle="Se stemningen fra fødselsdage, konfirmationer og intime fejringer."
      />

      {/* Contact Form */}
      <section className="py-20 bg-neutral-950 border-t border-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ContactForm
            title="Få et tilbud til din privatfest"
            subtitle="Send en uforpligtende forespørgsel, så vender jeg hurtigt tilbage."
          />
        </div>
      </section>
    </div>
  )
}
